import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import "@google/model-viewer";
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-ar-preview-dialog',
  templateUrl: './ar-preview-dialog.component.html',
  styleUrls: ['./ar-preview-dialog.component.scss']
})
export class ArPreviewDialogComponent implements OnInit {
  floorPlan: any;
  project: any;
  canPreview;

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.floorPlan = this.data.floorPlan;
    this.project = this.data.project;
    this.canPreview = this.data.canPreview;
  }

  getFileUrl(fileName?: string) {
    if (!fileName) {
      return null;
    }
    return environment.VERIFICATION_CODE_URL + 'files/' + this.project.projectCode + '/floor_plans/' + fileName
  }

  cancel() {
    this.dialogRef.close();
  }
}
